/**
 * Debug utility to check user profile data
 */

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export async function debugUserProfile(uid: string = 'Qfgstfi8GXZP9FyDL4lJNc7xUdw1') {
  console.log('🔍 Debugging profile for user:', uid);
  
  try {
    // Get profile directly from Firestore
    const profileDoc = await getDoc(doc(db, 'userProfiles', uid));
    
    if (!profileDoc.exists()) {
      console.log('❌ Profile document does not exist');
      return;
    }
    
    const profileData = profileDoc.data();
    console.log('✅ Profile data from Firestore:', profileData);
    
    // Check for undefined fields
    const fields = ['displayName', 'handle', 'bio', 'profilePicUrl', 'email'];
    console.log('\n📋 Field analysis:');
    fields.forEach(field => {
      const value = profileData[field];
      if (value === undefined) {
        console.log(`  ❌ ${field}: undefined`);
      } else if (value === null) {
        console.log(`  ⚠️ ${field}: null`);
      } else if (value === '') {
        console.log(`  ⚠️ ${field}: empty string`);
      } else {
        console.log(`  ✅ ${field}: "${value}"`);
      }
    });
    
    // Check sharing preferences
    if (profileData.sharingPreferences) {
      console.log('\n📤 Sharing preferences:', profileData.sharingPreferences);
    } else {
      console.log('\n⚠️ No sharing preferences found');
    }
    
    return profileData;
  } catch (error) {
    console.error('❌ Error debugging profile:', error);
  }
}

// Make function available in browser console
(window as any).debugUserProfile = debugUserProfile;

console.log('🛠️ Profile debug utility loaded. Use debugUserProfile() or debugUserProfile("uid") in console.');